import React from 'react'
import  DocViewer, { DocViewerRenderers }  from 'react-doc-viewer';

const EmbeddedPdf = ({ pdfUrl }) => {
  if (!pdfUrl) {
    return null
  }

  return (
    <DocViewer
      className='w-full h-full'
      pluginRenderers={DocViewerRenderers}
      documents={[{
        uri: pdfUrl,
        fileType: 'pdf'
      }]}
      config={{
        header: {
            disableHeader: true,
            disableFileName: true,
          }
        }}
    />
  )
}

export default EmbeddedPdf
